import clsx from "clsx";
import "../../index.css";
import { htmlToReactDangerousInnerHTML } from "../../util/general";
import React from "react";

export const Hotspot = React.forwardRef((props, ref) => {
  const {
    coordinates,
    className,
    template,
    style: extraStyle,
    ...rest
  } = props;
  const style = coordinates && {
    //Need to check if coordinates is defined, because this compo is also called to display a thumbnail in the styles tab
    position: "absolute",
    left: `${coordinates.x}%`,
    top: `${coordinates.y}%`,
  };
  //class names that Sirv Media Viewer assigns to hotspot element
  const SMVClassNames = template
    ? ""
    : "sirv-hotspot-pointer hotspot-pointer pulsating-point";

  return (
    <div
      draggable="false"
      className={clsx(SMVClassNames, className)}
      style={{ ...style, ...extraStyle }}
      dangerouslySetInnerHTML={htmlToReactDangerousInnerHTML(template)}
      ref={ref}
      {...rest}
    ></div>
  );
});
export default Hotspot;
